/* eslint-disable no-eval */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import Logo from "components/Logo";
import Card from "components/card";
import { Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import Footer from "components/footer/FooterAuthDefault";

const appName = process.env.REACT_APP_NAME!;

const NotFound: React.FC<{
  hideFooter?: boolean;
  isAuthenticated?: boolean;
}> = ({ hideFooter, isAuthenticated }) => {
  const userRole = localStorage.getItem("userRole")?.toLowerCase();
  useEffect(() => {
    const initialize = async () => {
      document.title = "Not Found";

      const appleTitle = document.querySelector(
        "meta[name='apple-mobile-web-app-title']"
      );
      if (appleTitle) appleTitle.setAttribute("content", appName);

      const element = document.querySelector(
        ".relative.float-right.h-full.min-h-screen.w-full.bg-white"
      );
      if (element) {
        element.classList.replace("bg-white", "bg-darkPrimary");
      }
    };

    initialize();
  }, []);

  const navigate = useNavigate();

  const navigateToOirinalPage = async () => {
    if (isAuthenticated) {
      window.location.href = `/${userRole.toLowerCase()}/dashboard`;
    } else {
      navigate(`/auth/sign-in`);
    }
  };

  return (
    <>
      <div className="flex h-full flex-col items-center justify-center px-4 py-12">
        <div className="mb-12">
          <Logo light={true} width="229px" />
        </div>

        <Card className="w-full max-w-md rounded-xl bg-white p-8 shadow-lg dark:bg-gray-800">
          <div className="flex flex-col items-center text-center">
            <div className="mb-4 text-6xl font-bold text-primary-500">404</div>

            <h2 className="mb-2 text-xl font-semibold text-navy-700 dark:text-white">
              Page Not Found
            </h2>

            <p className="mb-6 text-sm text-gray-600 dark:text-gray-300">
              The page you are looking for doesn't exist or has been moved.
            </p>

            <Button
              onClick={navigateToOirinalPage}
              className="w-full rounded-md bg-primary-500 py-3 text-sm font-medium text-white transition hover:bg-primary-600 active:bg-primary-700 dark:bg-primary-400 dark:hover:bg-primary-300 dark:active:bg-primary-200"
            >
              Back to {isAuthenticated ? "Dashboard" : "Home"}
            </Button>
          </div>
        </Card>
      </div>
      {!hideFooter && <Footer />}
    </>
  );
};

export default NotFound;
